import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guard/auth-guard.guard";
import { ErrorComponent } from "./components/error/error.component";
import { CarouselFullscreenComponent } from "./components/carousel-fullscreen/carousel-fullscreen.component";
import { NotAuthorizedComponent } from "./components/error/not-authorized/not-authorized.component";
import { ManagerGuard } from "./guard/manager.guard";
import { WaitingRoomComponent } from "./museum/components/waiting-room/waiting-room.component";
import { MuseumNoMissionComponent } from "./museum/components/museum-no-mission/museum-no-mission.component";
import { LayoutComponent } from "./components/layout/layout.component";

const routes: Routes = [
    {
        path: "",
        component: LayoutComponent,
        children: [
            {
                path: "dashboard",
                loadChildren: () =>
                    import("./dashboard/dashboard.module").then(
                        (m) => m.DashboardModule,
                    ),
                canActivate: [AuthGuard, ManagerGuard],
            },
            {
                path: "admin",
                loadChildren: () =>
                    import("./admin-wrapper.module").then(
                        (module_) => module_.NgxSmarterplanAdminWrapperModule,
                    ),
                canActivate: [AuthGuard, ManagerGuard],
            },
            { path: "", redirectTo: "/connect", pathMatch: "full" },
        ],
        canActivate: [AuthGuard],
    },
    {
        path: "museum-no-access",
        component: MuseumNoMissionComponent,
        canActivate: [AuthGuard],
    },
    { path: "no-mission", redirectTo: "/museum-no-access", pathMatch: "full" },
    { path: "fullscreen/:id", component: CarouselFullscreenComponent },
    { path: "notauthorized", component: NotAuthorizedComponent },
    { path: "auth", redirectTo: "/connect", pathMatch: "full" },
    { path: "visit/:id", redirectTo: "museum/:id", pathMatch: "full" },
    {
        path: "waiting/:id",
        component: WaitingRoomComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "museum/:id",
        loadChildren: () =>
            import("./museum/museum-visit.module").then(
                (m) => m.MuseumVisitModule,
            ),
        canActivate: [AuthGuard],
    },
    { path: "**", component: ErrorComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
})
export class AppRoutingModule { }
